<template>
    <TitleBox :titleBgColor="titleBgColor" bgColor="#ECECEC">
      <template v-slot:title>
        {{ name }}
      </template>
      <template v-slot:body>
        <div class="AddSingleSwitchWidget-wrapper-name-text lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
          {{$store.getters.language.texts.ChooseBothEnable_text}}
        </div>
        <div class="lxn-w100 lxn-display-flex-center">
          <SingleSwitch @switchClicked="toggleSwitchState()" :disabled="false" :state="state" bgColorOn="#00AEEF"
                        bgColorOff="#FFFFFF" bgColorPending="#CCCCCC"
                        handleColorOn="#FFFFFF" handleColorOff="#ececec"/>
        </div>
        <div class="AddSingleSwitchWidget-wrapper-name-text lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
          {{$store.getters.language.texts.ChooseInput_text}}
        </div>
        <select class="EditAutoThreewaySwitchWidget-dropdown lxn-border-round" @change="dropDownInputsChange()" v-model="targetInput" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
          <option selected value="">انتخاب</option>
          <option v-for="t in dropDownInputs" :key="t.value" :value="t.value">{{ t.name }}</option>
        </select>
        <div class="AddSingleSwitchWidget-wrapper-name-text lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
          {{$store.getters.language.texts.ChooseOutput_text}}
        </div>
        <select class="EditAutoThreewaySwitchWidget-dropdown lxn-border-round" v-model="targetOutput" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
          <option selected value="">انتخاب</option>
          <option v-for="t in dropDownOutputs" :key="t.value" :value="t.value">{{ t.name }}</option>
        </select>
        <div class="AddSingleSwitchWidget-wrapper-name-text lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
          {{$store.getters.language.texts.ChooseDelay_text}}
        </div>
        <div class="lxn-w100">
          <customInput v-model="delay" bgColor="#FFFFFF"
                       :placeHolder="$store.getters.language.texts.AddNewWidget_autoThreeWay_placeHolderDelay"
                       inputType="text"/>
        </div>
      </template>
    </TitleBox>
</template>

<script>

import TopNav from "@/components/TopNav.vue";
import CustomCurve from "@/components/CustomCurve.vue";
import CustomButton from "@/components/CustomButton.vue";
import CustomInput from "@/components/CustomInput.vue";
import TitleBox from "@/components/TitleBox.vue";
import DropDown from "@/components/DropDown.vue";
import SingleSwitch from "@/components/SingleSwitch.vue";

export default {
  name: 'AutoThreewaySwitchEditItem',
  props: {
    activeBoxIndex: Number,
    switch: Object,
  },
  components: {
    SingleSwitch,
    TitleBox, CustomInput, CustomButton,
    CustomCurve, TopNav, DropDown
  },
  mounted: function () {
  },
  data: function () {
    return {
      name: this.switch.name,
      state: this.switch.state,
      targetInput: this.switch.targetInput,
      targetOutput: this.switch.targetOutput,
      delay: this.switch.delay,
    }
  },
  computed: {
    titleBgColor: function () {
      return this.$store.state.themeMainColors[this.activeBoxIndex];
    },
    hubs: function() {
      return JSON.parse(JSON.stringify(this.$store.state.hubs));
    },
    dropDownInputs: function () {
      let index = 0;
      const data = [];
      for(var i = 0; i < this.$store.state.nodes.length; i++){
        for(var j = 0; j < this.$store.state.nodes[i].inputs.length; j++){
          data.push({
            name: this.$store.state.nodes[i].name + ' > ' + this.$store.state.nodes[i].inputs[j].name,
            icon: this.$store.state.nodes[i].inputs[j].icon,
            value: index++,
            data: {
              node: this.$store.state.nodes[i],
              input: this.$store.state.nodes[i].inputs[j],
              inputIndex: j,
            }
          })
        }
      }

      this.$store.state.hubs.map(x => [...(x.inputs?.internal || []).map(i => {
        return {
          node: {uuid: x.uuid, name: x.name},
          input: {parameterId: i.parameterId, name: i.name, type: "internal"},
        };
      }), ...(x.inputs?.expansion1 || []).map(i => {
        return {
          node: {uuid: x.uuid, name: x.name},
          input: {parameterId: i.parameterId, name: i.name, type: "internal"},
        };
      }), ...(x.inputs?.expansion2 || []).map(i => {
        return {
          node: {uuid: x.uuid, name: x.name},
          input: {parameterId: i.parameterId, name: i.name, type: "internal"},
        };
      })]).flatMap(x => x).forEach((x, j) => {
        data.push({
          name: x.node.name + ' > ' + x.input.name,
          icon: "hub",
          value: index++,
          data: {
            node: x.node,
            input: x.input,
            inputIndex: j,
          }
        })
      });
      return data;
    },
    dropDownOutputs: function () {
      let index = 0;
      const data = [];
      for(var i = 0; i < this.$store.state.nodes.length; i++){
        for(var j = 0; j < this.$store.state.nodes[i].outputs.length; j++){
          data.push({
            name: this.$store.state.nodes[i].name + ' > ' + this.$store.state.nodes[i].outputs[j].name,
            icon: this.$store.state.nodes[i].outputs[j].icon,
            value: index++,
            data: {
              node: this.$store.state.nodes[i],
              output: this.$store.state.nodes[i].outputs[j],
              outputIndex: j,
            }
          })
        }
      }

      this.$store.state.hubs.map(x => [...(x.outputs?.internal || []).map(i => {
        return {
          node: {uuid: x.uuid, name: x.name},
          output: {parameterId: i.parameterId, name: i.name, type: "internal"},
        };
      }), ...(x.outputs?.expansion1 || []).map(i => {
        return {
          node: {uuid: x.uuid, name: x.name},
          output: {parameterId: i.parameterId, name: i.name, type: "internal"},
        };
      }), ...(x.outputs?.expansion2 || []).map(i => {
        return {
          node: {uuid: x.uuid, name: x.name},
          output: {parameterId: i.parameterId, name: i.name, type: "internal"},
        };
      })]).flatMap(x => x).forEach((x, j) => {
        data.push({
          name: x.node.name + ' > ' + x.output.name,
          icon: "hub",
          value: index++,
          data: {
            node: x.node,
            output: x.output,
            outputIndex: j,
          }
        })
      });
      return data;
    },
    widget: function () {
      return this.$store.state.widgets[this.$route.params.widgetIndex];
    },
  },
  methods: {
    toggleSwitchState: function () {
      this.state = this.state === 'on' ? 'off' : 'on';
    },
    isValid: function () {
      return this.targetInput != null && this.targetInput !== '' && this.targetOutput != null && this.targetOutput !== '';

    },
    getData: function () {
      if (this.isValid()){
        const selected = this.dropDownInputs.find(d => d.value === this.targetInput);
        console.log(selected);
        return {
          name: this.name,
          state: this.state,
          targetInput: selected? selected.data: null,
          delay: this.delay,
          instructionIds: this.switch.instructionIds,
          index: this.switch.index,
        }
      }
      return null;
    },
    dropDownInputsChange: function () {
      if (this.targetInput === '' || this.targetInput === null) {
        this.state = 'off';
      }
    },
  },
}
</script>

<style scoped>


.EditAutoThreewaySwitchWidget-topCurve-wrapper {
  height: 200px;
}

.EditAutoThreewaySwitchWidget-main {
  z-index: 2;
}

.EditAutoThreewaySwitchWidget-main-wrapper {
  width: calc(100% - 36px);
  margin-top: -150px;
  z-index: 2;
  background-color: #ffffff;
  margin-bottom: 14px;
  padding: 14px;
}

.TitleBox.lxn-w100.lxn-border-round.lxn-overflow-hidden {
  background-color: rgb(236, 236, 236);
}

.EditAutoThreewaySwitchWidget-button {
  width: calc(100% - 36px);
  margin-bottom: 14px;
}

.EditAutoThreewaySwitchWidget-wrapper-colors {
}

.EditAutoThreewaySwitchWidget-color {
  width: 100%;
  margin-left: 8px;
  padding: 5px;
}

.EditAutoThreewaySwitchWidget-color-item {
  float: left;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  margin-bottom: 20px;
}

.EditAutoThreewaySwitchWidget-selectedColor {
  background-color: transparent;
  border-style: solid;
  border-color: #FFFFFF;
  border-width: 4px;
  opacity: 0;
}

.EditAutoThreewaySwitchWidget-color.active .EditAutoThreewaySwitchWidget-selectedColor {
  opacity: 1;
}

.EditAutoThreewaySwitchWidget-wrapper-name-text {
  padding-top: 20px;
  line-height: 30px;
  color: #52626C;
}

.EditAutoThreewaySwitchWidget-wrapper-name-text:first-child {
  height: 30px;
  padding-top: 0;
}

.EditAutoThreewaySwitchWidget-wrapper-fieldTitles {
  height: 30px;
  line-height: 30px;
  color: #52626C;
}

.EditAutoThreewaySwitchWidget-commandDelay-button {
  -webkit-appearance: none;
  transition: opacity 0.5s ease;
  background: #1EA5DE;
  border: 0;
  border-radius: 7px;
  overflow: hidden;
  color: #fff;
  cursor: pointer;
  float: left;
  font-size: 20px;
  height: 40px;
  margin: 0;
  width: 40px;
}

.EditAutoThreewaySwitchWidget-commandDelay-button:hover {
  opacity: 0.5;
}

.EditAutoThreewaySwitchWidget-commandDelay-button:hover {
  opacity: 0.5;
}

.EditAutoThreewaySwitchWidget-commandDelay-button:focus {
  outline: 0;
  outline-offset: 0;
}

.EditAutoThreewaySwitchWidget-wrapper-button2 {
  width: calc(100% - 36px);
  margin-top: 25px;
  margin-bottom: 14px;
}

.EditAutoThreewaySwitchWidget-wrapper-commands {
  height: 70px;
  background-color: #FFFFFF;
  padding: 5px;
  margin-top: 14px;
}

.EditAutoThreewaySwitchWidget-wrapper-commands:first-child {
  margin-top: 0;
}

.EditAutoThreewaySwitchWidget-wrapper-command {
  height: 20px;
  line-height: 20px;
}

.EditAutoThreewaySwitchWidget-wrapper-commands-trash {
  left: 5px;
  top: 5px;
  width: 30px;
  height: 30px;
}

.EditAutoThreewaySwitchWidget-dropdown {
  width: 100%;
  height: 50px;
  background-color: white;
  border: unset;
  box-shadow: unset;
  text-align: center;
}
</style>
